export const PRODUCTION_MODE = "__production_mode__";
export const DEFAULT_AMOUNT_TO_ENABLE_UPI = 500;
export const DEFAULT_AMOUNT_TO_ENABLE_PAYTM = 1000;
export const SIKKA_PRO_PACKAGE = 'com.sikka.freemoney.pro';
export const SIKKA_PRO_TYPE = 'pro';
export const BROWSER_SUPPORT_WARNING = 'browser_support_warning';
